export default __webpack_public_path__ + "static/media/icon-transaction.47876c74.svg";